import Vue from 'vue'
import Vuex from 'vuex'

import auth from './modules/auth'
import bridge from './modules/bridge'

Vue.use(Vuex)

export default new Vuex.Store({
  strict: false, // causes mutation error after file upload why?
  state: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
    auth: auth,
    bridge: bridge,
  }
})
